var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 62,
    viewBox: "0 0 81 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.9223 0.656455L25.8829 46.6958L9.07768 29.7155C8.20241 29.0153 6.80197 29.0153 6.10175 29.7155L1.02516 34.7921C0.324945 35.4923 0.324945 36.8928 1.02516 37.7681L24.4825 61.0503C25.3578 61.9256 26.5832 61.9256 27.4584 61.0503L79.9748 8.53392C80.6751 7.8337 80.6751 6.43326 79.9748 5.55799L74.8983 0.656455C74.198 -0.218818 72.7976 -0.218818 71.9223 0.656455Z",
    fill: "#00AC97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.a70930f51e2441ec6e4a0b179fc61489.svg";
export { ForwardRef as ReactComponent };